var React = require('react');

function Mobile (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.002 7.5a7.5 7.5 0 017.5-7.5h15a7.5 7.5 0 017.5 7.5v33a7.5 7.5 0 01-7.5 7.5h-15a7.5 7.5 0 01-7.5-7.5v-33zm3 0a4.5 4.5 0 014.5-4.5h15a4.5 4.5 0 014.5 4.5V36h-24V7.5zm24 31.5v1.5a4.5 4.5 0 01-4.5 4.5h-15a4.5 4.5 0 01-4.5-4.5V39h24z"}));
}

Mobile.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Mobile;

Mobile.default = Mobile;
